import * as settings from "../../constants/settings";

/**
 * @class PrinterTask
 */
export default class PrinterTask {
    /**
     * @param {Number}          index
     * @param {String | null}   name
     * @param {String | null}   printer
     * @param {String | null}   template
     * @param {String | null}   action
     * @param {Number}          copies
     * @param {Boolean}         preview
     * @param {String | null}   variable
     */
    constructor(index, name, printer, template, action, copies, preview, variable) {
        this._index = index;
        this._name = name || null;
        this._printer = printer;
        this._template = template;
        this._action = action || settings.PRINT_TASK_ACTION_ALL;
        this._copies = copies;
        this._preview = preview;
        this._variable = variable || null;
    }

    /**
     * @return {Number}
     */
    get index() {
        return this._index;
    }

    /**
     * @param {Number} index
     */
    set index(index) {
        this._index = index;
    }

    /**
     * @return {String | null}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String | null}   name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String | null}
     */
    get printer() {
        return this._printer;
    }

    /**
     * @param {String | null}   printer
     */
    set printer(printer) {
        this._printer = printer;
    }

    /**
     * @return {String | null}
     */
    get template() {
        return this._template;
    }

    /**
     * @param {String | null}   template
     */
    set template(template) {
        this._template = template;
    }

    /**
     * @return {Number}
     */
    get copies() {
        return this._copies;
    }

    /**
     * @param {Number} copies
     */
    set copies(copies) {
        this._copies = copies;
    }

    /**
     * @return {Boolean}
     */
    get preview() {
        return this._preview;
    }

    /**
     * @param {Boolean} preview
     */
    set preview(preview) {
        this._preview = preview;
    }

    /**
     * @return {String | null}
     */
    get action() {
        return this._action;
    }

    /**
     * @param {String | null} action
     */
    set action(action) {
        this._action = action;
    }

    /**
     * @return {String | null}
     */
    get variable() {
        return this._variable;
    }

    /**
     * @param {String | null}   variable
     */
    set variable(variable) {
        this._variable = variable;
    }

    /**
     * @param   {String}    newIndex
     * @return  {Object}
     */
    format = (newIndex) => {
        return {
            index: newIndex,
            name: this._name,
            printer: this._printer,
            template: this._template,
            action: this._action,
            copies: this._copies,
            preview: this._preview,
            variable: this._variable
        };
    };

    isPrintVariableValid = (printData, variable) => {
        if (typeof variable !== "string") {
            return false;
        }

        let not = false;

        if (variable[0] === "!") {
            not = true;
            variable = variable.substr(1);
        }

        switch (typeof printData[variable]) {
            case "undefined":
                return not;
            case "object":
                if (printData[variable] === null) {
                    return not;
                }

                if (Array.isArray(printData[variable])) {
                    return not ? printData[variable].length === 0 : printData[variable].length > 0;
                }

                return !not;
            case "string":
                return not ? printData[variable].trim().length === 0 : printData[variable].trim().length > 0;
            case "number":
                return not ? printData[variable] === 0 : printData[variable] > 0;
            case "boolean":
                return not ? !printData[variable] : printData[variable];
            default:
                return false;
        }
    };

    /**
     * @param   {Boolean}   quickTint
     * @param   {Object}    printData
     * @return  {Boolean}
     */
    isActive = (quickTint, printData) => {
        if (this._copies === 0) {
            return false;
        }

        let active = 0;

        if (this._action === settings.PRINT_TASK_ACTION_ALL) {
            active++;
        }

        if (quickTint) {
            active += this._action === settings.PRINT_TASK_ACTION_QUICK_TINT ? 1 : 0;
        } else {
            active += this._action !== settings.PRINT_TASK_ACTION_QUICK_TINT ? 1 : 0;
        }

        if (this._variable !== null && printData !== null) {
            if (active === 0) {
                return false;
            }

            if (Array.isArray(this._variable)) {
                return this._variable.every((variable) => this.isPrintVariableValid(printData, variable));
            }

            return this.isPrintVariableValid(printData, this._variable);
        }

        return active > 0;
    };
}
